import { useLayoutEffect, useRef } from 'react';

import { Section } from './LockedSection.styles';
import type { LockedSectionProps } from './LockedSection.types';

export function LockedSection({ locked, children }: LockedSectionProps) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    ref.current?.toggleAttribute('inert', locked);
  }, [locked]);

  return (
    <Section ref={ref} $locked={locked}>
      {children}
    </Section>
  );
}
